import React, { FC, ReactElement } from "react";
import { useHistory } from "react-router-dom";

import { useBackButtonStyles } from "./BackButtonStyles";
import { ArrowIcon } from "../../icons";
import ActionIconButton from "../ActionIconButton/ActionIconButton";


export interface BackButtonProps {
  onBack?: () => void;
}

const BackButton: FC<BackButtonProps> = ({ onBack }): ReactElement => {

    const classes = useBackButtonStyles();
    const history = useHistory();

    const handleClickButton = (): void => {
        if (onBack) onBack();
        history.goBack();
    };

    return (
        <div className={classes.container}>
            <ActionIconButton actionText={"Back"} onClick={handleClickButton} icon={ArrowIcon} />
        </div>
    );
};

export default BackButton;
